export const statusKeys = {
  inProgress: 'inProgress',
  onApprovePortf: 'onApprovePortf',
  returnedByPortf: 'returnedByPortf',
  onApproveHeadSP: 'onApproveHeadSP',
  returnedByHeadSP: 'returnedByHeadSP',
  returnedByExperts: 'returnedByExperts',
  onApproveExperts: 'onApproveExperts',
  expertsApproved: 'expertsApproved',
  expertsDeclined: 'expertsDeclined',
  approved: 'approved',
};

export const statusLabels = {
  inProgress: 'На заполнении',
  onApprovePortf: 'У руководителя портфеля',
  returnedByPortf: 'На доработке',
  onApproveHeadSP: 'У руководителя СП',
  returnedByHeadSP: 'На доработке',
  onApproveExperts: 'На рассмотрении ЭГ',
  returnedByExperts: 'На доработке',
  expertsApproved: 'Одобрено ЭГ',
  expertsDeclined: 'Не одобрено ЭГ',
  approved: 'Утвержден',
};

export const statusLabels_extra = {
  draft: 'Черновик',
  onApprovePortf: 'У руководителя портфеля',
  onApproveHeadSP: 'У руководителя СП',
  returned: 'На доработке',
  onApproveExperts: 'На рассмотрении ЭГ',
  expertsApproved: 'Одобрен ЭГ',
  expertsDeclined: 'Отклонен ЭГ',
};

export function filterReportStatus(term, rowData) {
  return term.length === 0 || term.includes(rowData.reportStatus) || (term === 'returned' && rowData.reportStatus.includes('returned'));
}
export function filterProjStatus(term, rowData) {
  return term.length === 0 || term.includes(rowData.status)
}

export const statusFull = {
  inProgress: {
    key: statusKeys.inProgress,
    label: statusLabels.inProgress,
    color: 'info',
  },
  onApprovePortf: {
    key: statusKeys.onApprovePortf,
    label: statusLabels.onApprovePortf,
    bg: 'warning',
  },
  returnedByPortf: {
    key: statusKeys.returnedByPortf,
    label: statusLabels.returnedByPortf,
    bg: 'danger',
  },
  onApproveHeadSP: {
    key: statusKeys.onApproveHeadSP,
    label: statusLabels.onApproveHeadSP,
    bg: 'warning',
  },
  returnedByHeadSP: {
    key: statusKeys.returnedByHeadSP,
    label: statusLabels.returnedByHeadSP,
    bg: 'danger',
  },
  onApproveExperts: {
    key: statusKeys.onApproveExperts,
    label: statusLabels.onApproveExperts,
    bg: 'warning',
  },
  returnedByExperts: {
    key: statusKeys.returnedByExperts,
    label: statusLabels.returnedByExperts,
    bg: 'danger',
  },
  expertsApproved: {
    key: statusKeys.expertsApproved,
    label: statusLabels.expertsApproved,
    bg: 'success',
  },
  expertsDeclined: {
    key: statusKeys.expertsDeclined,
    label: statusLabels.expertsDeclined,
    bg: 'danger',
  },
  approved: {
    key: statusKeys.approved,
    label: statusLabels.approved,
    bg: 'success',
  },
};
